import * as React from "react";
import {useDispatch, useSelector} from "react-redux"
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { FormControl, Stack } from "@mui/material";
import { useEffect } from "react";
import useSkuImageUpload from "../../hooks/useSkuImageUpload";
import { ToastContainer, toast } from "react-toastify";
import useSkuList from "../../hooks/useSkuList";
import useUpdateSku from "../../hooks/useUpdateSku";
import { resetSkuFormData } from "../../slice/skuSlice";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function EditSku({ setOpen, open, skuEditId, skuRowData, shapeID }) {
  const [error, setError] = React.useState({});
  const [form, setForm] = React.useState({});
  const statusList = ["Active", "Inactive"];
  const [enable, setEnable] = React.useState(false);
  const dispatch = useDispatch();
  const [imageDimensions, setImageDimensions] = React.useState({
    width: 0,
    height: 0,
  });
  const [imageSize, setImageSize] = React.useState(0);
  //Redux
  const categoryList = useSelector((store) => store.category.categoryList);
  const currentImageSelected=useSelector((state)=>state.sku.skuFormData)

  //useEffect
  useEffect(() => {
    setForm((prev) => ({
      ...prev,
      sku_id: skuEditId,
    }));
  }, [skuEditId]);
  
  useEffect(() => {
    setForm((prev) => ({
      ...prev,
      skuRowData: skuRowData,
      sku_name: String(skuRowData?.sku_name),
      hindi_name:skuRowData?.hindi_name,
      gujarati_name:skuRowData?.gujarati_name,
      category_id: skuRowData?.category_id,
      ptr: String(skuRowData?.ptr),
      ptw: String(skuRowData?.ptw),
      mrp: String(skuRowData?.mrp),
      sp: String(skuRowData?.sp),
      scheme: String(skuRowData?.scheme),
      category_name:String(skuRowData?.category_name),
      selectedImage:skuRowData?.sku_image      
    }));
  }, [skuRowData]);

  useEffect(() => {
    setEnable(false);
  }, [currentImageSelected]);
  
  //Api Calls
  const getSkuImageUpload = useSkuImageUpload();
  const getAllSkuList = useSkuList();
  const updateSkuDetails = useUpdateSku(form);

  const isValid = () => {
    let success = true;
    let err = {};

    if (
      form.sku_name?.trim() === "" ||
      form.sku_name?.trim() === undefined ||
      form.sku_name?.trim() === null
    ) {
      err.sku_name = "**SKU Name Cannot be Empty**";
      success = false;
    }
    if (
      form.hindi_name?.trim() === "" ||
      form.hindi_name?.trim() === undefined ||
      form.hindi_name?.trim() === null
    ) {
      err.hindi_name = "**Hindi Name Cannot be Empty**";
      success = false;
    }
    if (
      form.gujarati_name?.trim() === "" ||
      form.gujarati_name?.trim() === undefined ||
      form.gujarati_name?.trim() === null
    ) {
      err.gujarati_name = "**Gujarati Name Cannot be Empty**";
      success = false;
    }
    if (
      form.scheme?.trim() === "" ||
      form.scheme?.trim() === undefined ||
      form.scheme?.trim() === null
    ) {
      err.scheme = "**Scheme cannot be Empty**";
      success = false;
    }
    
    // if (
    //   form.mrp?.trim() === "" ||
    //   form.mrp?.trim() === undefined ||
    //   form.mrp?.trim() === null ||
    //   parseFloat(form.mrp) <= 0
    // ) {
    //   err.mrp = "**MRP must be a non-zero positive number**";
    //   success = false;
    // }
    
    // if (
    //   form.sp?.trim() === "" ||
    //   form.sp?.trim() === undefined ||
    //   form.sp?.trim() === null ||
    //   parseFloat(form.sp) <= 0
    // ) {
    //   err.sp = "**Price must be a non-zero positive number**";
    //   success = false;
    // }
    if (
      form.selectedImage?.trim() === "" ||
      form.selectedImage?.trim() === undefined ||
      form.selectedImage?.trim() === null
    ) {
      err.selectedImage = "**Image should be selected**";
      success = false;
    // } else if (
    //   imageDimensions.width !== 200 ||
    //   imageDimensions.height !== 200
    // ) {
    //   err.selectedImage = "**Image should be 200x200 pixels**";
    //   success = false;
    } else if (imageSize > 50 * 1024) {
      err.selectedImage = "**Image size should be less than 50KB**";
      success = false;
    }

    // if (
    //   form.category_id === 0 ||
    //   form.category_id === undefined ||
    //   form.category_id === null
    // ) {
    //   err.category = "**Category Cannot be Empty**";
    //   success = false;
    // }
    setError(err);
    return success;
  };

  const handleClose = () => {
    dispatch(resetSkuFormData());
    setOpen(false);
    setError({});
  };

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    setForm((prev) => ({
      ...prev,
      [e.target.name]: selectedImage,
    }));
    setEnable(true);
    if (selectedImage.size > 50 * 1024) {
      setError({ selectedImage: "**Image size should be less than 50KB**" });
      setForm((prev) => ({
        ...prev,
        selectedImage: null,
      }));
      return;
    }
    const formData = new FormData();
    formData.append("file", selectedImage);

    // Update image dimensions and size
    const img = new Image();
    img.src = URL.createObjectURL(selectedImage);

    img.onload = () => {
      setImageDimensions({ width: img.width, height: img.height });
      setImageSize(selectedImage.size);
    };

    getSkuImageUpload(formData);
    setError({});
    if (selectedImage) {
      setForm((prev) => ({
        ...prev,
        selectedImage: selectedImage.name,
      }));
    } else {
      setForm((prev) => ({
        ...prev,
        selectedImage: null,
      }));
    }
  };
  const handleCategory = (e) => {
    let categoryId = 0;
    for (let i = 0; i < categoryList?.length; i++) {
      if (e.target.value === categoryList[i]?.category_name) {
        categoryId = categoryList[i]?.category_id;
        break;
      }
    }

    setForm((prev) => ({
      ...prev,
      category_id: categoryId,
      category_name: e.target.value
    }));
  };

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isValid()) {
    await updateSkuDetails();
    await getAllSkuList(shapeID);
    setOpen(false);
    setForm({});
    dispatch(resetSkuFormData());
    }
  };

  //console

  return (
    <>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div>
        <Modal
          open={open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <FormControl
              fullWidth
              size="small"
              sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}
            >
              <Stack
                sx={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}
              >
                <label>SKU Name</label>
                <input
                  variant="outlined"
                  name="sku_name"
                  value={form?.sku_name}
                  // placeholder={form?.skuRowData?.sku_name}
                  onChange={handleChange}
                  style={{
                    height: "1.8rem",
                    paddingLeft: "0.5rem",
                    fontSize: "0.9rem",
                  }}
                />
                {error.sku_name && (
                  <p
                    style={{
                      color: "red",
                      justifyContent: "center",
                      display: "flex",
                      fontSize: "0.8rem",
                      marginTop: "-0.1rem",
                    }}
                  >
                    {error.sku_name}
                  </p>
                )}
              </Stack>
              
              <Stack
                sx={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}
              >
                <label>Sku Name(Hindi)</label>
                <input
                  variant="outlined"
                  name="hindi_name"
                  placeholder="Enter Sku name"
                  value={form?.hindi_name  ? form?.hindi_name : " " }
                  onChange={handleChange}
                  style={{
                    height: "1.8rem",
                    paddingLeft: "0.5rem",
                    fontSize: "0.9rem",
                  }}
                />
                {error.hindi_name && (
                  <p
                    style={{
                      color: "red",
                      justifyContent: "center",
                      display: "flex",
                      fontSize: "0.8rem",
                      marginTop: "-0.1rem",
                    }}
                  >
                    {error.hindi_name}
                  </p>
                )}
              </Stack>
              
              <Stack
                sx={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}
              >
                <label>Sku Name(Gujarati)</label>
                <input
                  variant="outlined"
                  name="gujarati_name"
                  placeholder="Enter Sku name"
                  value={form?.gujarati_name  ? form?.gujarati_name : " " }
                  onChange={handleChange}
                  style={{
                    height: "1.6rem",
                    paddingLeft: "0.5rem",
                    fontSize: "0.9rem",
                  }}
                />
                {error.gujarati_name && (
                  <p
                    style={{
                      color: "red",
                      justifyContent: "center",
                      display: "flex",
                      fontSize: "0.8rem",
                      marginTop: "-0.1rem",
                    }}
                  >
                    {error.gujarati_name}
                  </p>
                )}
              </Stack>

              <Stack
                sx={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}
              >
                <label>Category</label>
                <select
                  style={{
                    height: "1.8rem",
                    fontSize: "0.9rem",
                    cursor: "pointer",
                  }}
                  name="category"
                  value={form.category_name}
                  onChange={handleCategory}
                >
                  <option value="" disabled selected>
                    Choose Category
                  </option>
                  {categoryList?.map(
                    (item) =>
                      // Only render the option if the status is true
                      item.status && (
                        <option key={item.id} value={item.category_name}>
                          {item.category_name}
                        </option>
                      )
                  )}
                </select>
                {error.category && (
                  <p
                    style={{
                      color: "red",
                      justifyContent: "center",
                      display: "flex",
                      fontSize: "0.8rem",
                      marginTop: "-0.1rem",
                    }}
                  >
                    {error.category}
                  </p>
                )}
              </Stack>
              <Stack
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.4rem",
                  }}
                >
                  <label>Ptr</label>
                  <input
                    variant="outlined"
                    name="sp"
                    type="number"
                    value={form?.sp}
                    // placeholder={form?.skuRowData?.ptr}
                    onChange={handleChange}
                    style={{
                      height: "1.8rem",
                      paddingLeft: "0.5rem",
                      fontSize: "0.9rem",
                    }}
                  />
                  {error.sp && (
                    <p
                      style={{
                        color: "red",
                        justifyContent: "center",
                        display: "flex",
                        fontSize: "0.8rem",
                        marginTop: "-0.1rem",
                      }}
                    >
                      {error.sp}
                    </p>
                  )}
                </Stack>
                <Stack
                sx={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}
              >
                <label>Mrp</label>
                <input
                  variant="outlined"
                  name="mrp"
                  type="number"
                  value={form?.mrp}
                  onChange={handleChange}
                  style={{
                    height: "1.8rem",
                    paddingLeft: "0.5rem",
                    fontSize: "0.9rem",
                  }}
                />
                {error.mrp && (
                  <p
                    style={{
                      color: "red",
                      justifyContent: "center",
                      display: "flex",
                      fontSize: "0.8rem",
                      marginTop: "-0.1rem",
                    }}
                  >
                    {error.mrp}
                  </p>
                )}
              </Stack>
                {/* <Stack
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.4rem",
                  }}
                >
                  <label>Ptw</label>
                  <input
                    variant="outlined"
                    name="ptw"
                    type="number"
                    value={form?.ptw}
                    // placeholder={form?.skuRowData?.ptw}
                    onChange={handleChange}
                    style={{
                      height: "1.8rem",
                      paddingLeft: "0.5rem",
                      fontSize: "0.9rem",
                    }}
                  />
                  {error.ptw && (
                    <p
                      style={{
                        color: "red",
                        justifyContent: "center",
                        display: "flex",
                        fontSize: "0.8rem",
                        marginTop: "-0.1rem",
                      }}
                    >
                      {error.ptw}
                    </p>
                  )}
                </Stack> */}
              </Stack>

              {/* <Stack
                sx={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}
              >
                <label>Mrp</label>
                <input
                  variant="outlined"
                  name="mrp"
                  type="number"
                  value={form?.mrp}
                  onChange={handleChange}
                  style={{
                    height: "1.8rem",
                    paddingLeft: "0.5rem",
                    fontSize: "0.9rem",
                  }}
                />
                {error.mrp && (
                  <p
                    style={{
                      color: "red",
                      justifyContent: "center",
                      display: "flex",
                      fontSize: "0.8rem",
                      marginTop: "-0.1rem",
                    }}
                  >
                    {error.mrp}
                  </p>
                )}
              </Stack> */}

              {/* <Stack
                sx={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}
              >
                <label>Ptr</label>
                <input
                  variant="outlined"
                  name="sp"
                  type="number"
                  value={form?.sp}
                  onChange={handleChange}
                  style={{
                    height: "1.8rem",
                    paddingLeft: "0.5rem",
                    fontSize: "0.9rem",
                  }}
                />
                {error.sp && (
                  <p
                    style={{
                      color: "red",
                      justifyContent: "center",
                      display: "flex",
                      fontSize: "0.8rem",
                      marginTop: "-0.1rem",
                    }}
                  >
                    {error.sp}
                  </p>
                )}
              </Stack> */}

              <Stack
                sx={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}
              >
                <label>Scheme</label>
                <input
                  variant="outlined"
                  name="scheme"
                  type="text"
                  value={form?.scheme}
                  onChange={handleChange}
                  style={{
                    height: "1.8rem",
                    paddingLeft: "0.5rem",
                    fontSize: "0.9rem",
                  }}
                />
                {error.scheme && (
                  <p
                    style={{
                      color: "red",
                      justifyContent: "center",
                      display: "flex",
                      fontSize: "0.8rem",
                      marginTop: "-0.1rem",
                    }}
                  >
                    {error.scheme}
                  </p>
                )}
              </Stack>

              <Stack
                sx={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}
              >
                <label>Status</label>
                <select
                  style={{
                    height: "1.8rem",
                    fontSize: "0.9rem",
                    cursor: "pointer",
                  }}
                  name="status"
                  onChange={handleChange}
                >
                  <option value="" disabled selected>
                    {form?.skuRowData?.status === true ? "Active" : "InActive"}
                  </option>
                  {statusList.map((item) => (
                    <option>{item}</option>
                  ))}
                </select>
                {error.category && (
                  <p
                    style={{
                      color: "red",
                      justifyContent: "center",
                      display: "flex",
                      fontSize: "0.8rem",
                      marginTop: "-0.1rem",
                    }}
                  >
                    {error.category}
                  </p>
                )}
              </Stack>

              <Stack
                sx={{ display: "flex", flexDirection: "row", gap: "0.4rem" }}
              >
                <img
                  style={{ width: "2rem" }}
                  src={currentImageSelected?.full_path??form?.skuRowData?.sku_image}
                />
                <label htmlFor="sku_image" style={{ cursor: "pointer" }}>
                  <input
                    id="sku_image"
                    type="file"
                    size="small"
                    accept="image/*"
                    name="sku_image"
                    style={{
                      display: "none",
                    }}
                    onChange={handleImageChange}
                  />
                  <div
                    style={{
                      height: "1.8rem",
                      paddingLeft: "0.5rem",
                      fontSize: "0.9rem",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      width:"100%"
                    }}
                  >
                    Choose Image
                  </div>
                </label>
                {error.selectedImage && (
                  <p
                    style={{
                      color: "red",
                      justifyContent: "center",
                      display: "flex",
                      fontSize: "0.8rem",
                      marginTop: "-0.1rem",
                    }}
                  >
                    {error.selectedImage}
                  </p>
                )}
              </Stack>
              <Stack
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  gap: "0.4rem",
                }}
              >
                <Button
                  sx={{
                    background: "white",
                    color: "#DC1D13",
                    border: "2px solid #DC1D13",
                    height: "1.8rem",
                  }}
                  onClick={handleClose}
                >
                  Discard
                </Button>
                <Button
                  sx={{ background: "#DC1D13", color: "white",height: "1.8rem", ":hover":{backgroundColor:"#DC1D13"} }}
                  onClick={handleSubmit} disabled={enable}
                >
                  Update
                </Button>
              </Stack>
            </FormControl>
          </Box>
        </Modal>
      </div>
    </>
  );
}
